import AgentsAvatar from './AgentsAvatar.js'
import Emoji from '../components/Emoji.js'

import store from '@sb/store'
var sb = require('@sb/util')

export default {
	name: 'Header',

	props: ['convoKey', 'mode', 'hideBackButton', 'agentsJoined'],

	data () {
		return { openMenu: false, ...store.bind(this, ['convoM', 'convoEventM', 'account', 'accountSetting', 'user']) }
	},

	render () {
		return this.mode === 'collapsed' ? this.renderCollapsedHeader() : this.renderExpandedHeader()
	},

	methods: {
		renderExpandedHeader () {
			let layout = sb.get(this.accountSetting, 'header.layout')
			return layout == 'social' ? this.renderSocial() : this.renderTeam()
		},
		renderCollapsedHeader () {
			let agentIdsJoined = sb.map(this.agentsJoined, agent => agent.id)
			return (
				<div class="widget-header widget-header--collapsed">
					{this.renderBackButton()}
					<AgentsAvatar mode="secondary" agent_ids={agentIdsJoined}/>
					<div class="widget-header--title-container">
						<div class="widget-header--title">{this.getTitle()}</div>
						<div class="pos-relative">
							<div class="widget-header--description" data-tooltip={this.getDesc()}>{this.getDesc()}</div>
						</div>
					</div>
					{this.renderCloseButton()}
				</div>
			)
		},

		renderSocial () {
			let links = sb.get(this.accountSetting, 'header.links') || []
			let $links = sb.map(links, link => {
				if (!link.url || !link.type || link.type === 'subiz') return null
				if (link.type === 'email') {
					return (
						<div>
							<a href={`mailto:${link.url}`} title={link.url}>
								<i class={`social__links-logo social__links-logo--${link.type}`}></i>
							</a>
						</div>
					)
				}

				return (
					<div>
						<a href={link.url} target="_blank" title={link.url}>
							<i class={`social__links-logo social__links-logo--${link.type}`}></i>
						</a>
					</div>
				)
			})
			const DEFTEAMINTO = `Chúng tôi sẵn sàng trợ giúp :wave:.
Vui lòng hỏi chúng tôi bất cứ điều gì hoặc chia sẻ phản hồi của bạn`
			var teamintro = sb.get(this, 'accountSetting.introduction') || this.$t('team_intro') || DEFTEAMINTO
			var tags = sb.extractText(teamintro).map(tag => {
				if (tag.type === 'emoji') return <Emoji emojiCode={tag.text} />
				return tag.text
			})

			return (
				<div >
					<div class="widget-header--top-wrapper">
						{this.renderBackButton()}
						<div class="widget-header--title">{this.getTitle()}</div>
						{this.renderCloseButton()}
					</div>
					<div class="social">
						<div>
					<img class="social__account-logo" src={sb.replaceFileUrl(sb.get(this.account, 'logo_url'))} />
						</div>
						<div class="social__right">
							<div class="social__introduction">{tags}</div>
							<div class="social__links">{$links}</div>
						</div>
					</div>
				</div>
			)
		},

		renderTeam () {
			const DEFTEAMINTO = `Chúng tôi sẵn sàng trợ giúp :wave:.
Vui lòng hỏi chúng tôi bất cứ điều gì hoặc chia sẻ phản hồi của bạn`
			var teamintro = sb.get(this, 'accountSetting.introduction') || this.$t('team_intro') || DEFTEAMINTO
			var tags = sb.extractText(teamintro).map(tag => {
				if (tag.type === 'emoji') return <Emoji emojiCode={tag.text} />
				return tag.text
			})

			return (
				<div>
					<div class="widget-header--top-wrapper">
						{this.renderBackButton()}
						<div class="widget-header--title">{this.getTitle()}</div>
						{this.renderCloseButton()}
					</div>
					<div class="widget-header--avatar-wrapper">
						<AgentsAvatar mode="primary" />
					</div>
					<div class="widget-header--title-container">
						<div class="pos-relative">
							<div class="widget-header--description">{tags}</div>
						</div>
					</div>
				</div>
			)
		},

		getJoinedNameMember (agents) {
			return sb.map(agents, agent => agent.name).join(', ')
		},

		getTitle () {
			return this.getJoinedNameMember(this.agentsJoined) || sb.get(this, 'accountSetting.title') || sb.get(this, 'account.name') || this.$t('widget_title')
		},

		getDesc () {
			let state = sb.get(store.accountSetting, 'is_online') ? this.$t('agent_online') : this.$t('agent_offline')
			return sb.get(this, 'accountSetting.introduction') || state
		},

		renderBackButton () {
			if (this.hideBackButton) return null
			if (sb.size(this.convoM) === 0) return null
			var $unreadcount = null
			var unreadcount = sb.size(sb.filter(this.convoEventM, (events, key) => !sb.isConvoSeen(this.user.id, events) && key !== this.convoKey))
			if (unreadcount !== 0) {
				$unreadcount = <span class="widget-header--total-unread-convo">{unreadcount}</span>
			}
			return (
				<div class={`widget-header--wrap-button-back ${ unreadcount ? 'widget-header--has-convo-unred' : ''}`} vOn:click_stop_prevent={this.onBackClick}>
					<div
						class="widget-header--button-back"
						data-tooltip={this.$t('menu_back')}>
					</div>
					{$unreadcount}
				</div>
			)
		},

		renderCloseButton () {
			return (
				<div
					class="widget-header--button widget-header--button-close"
					data-tooltip={this.$t('close')}
					data-tooltip-position="bottom"
					vOn:click_stop_prevent={this.onCloseClick}>
					<span class="widget-header--button-close-icon"></span>
				</div>
			)
		},

		onBackClick () {
			this.hideMenu()
			this.$emit('gotoList')
		},

		hideMenu () {
			this.openMenu = false
		},
		onMoreClick () {
			this.openMenu = !this.openMenu
		},

		onCloseClick () {
			this.$emit('close')
		},
	},
}
